// The "this failed to load" state for an inline region (a metric strip, a
// table body) — the customer-app counterpart of the Command Center's
// LoadState error branch, and there for the same reason: a rejected fetch
// must never fall through to an empty state. "אין זיכויים" and "the server is
// unreachable" are different facts, and rendering the first when the second
// is true is how a user concludes their data is gone.
//
// A toast is the wrong instrument here — load failures happen on mount, so a
// toast would fire before the user has looked at anything and then vanish,
// leaving the same lying empty state behind. This stays on screen and offers
// the retry.
export default function InlineLoadError({ message, onRetry }) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: 12, flexWrap: 'wrap', padding: '20px 12px',
        color: '#b91c1c', fontSize: '0.9rem', fontWeight: 600,
      }}
    >
      <span>{message}</span>
      {onRetry && (
        <button type="button" className="btn btn-sm btn-secondary" onClick={onRetry}>
          נסה שוב
        </button>
      )}
    </div>
  );
}
